import { Field, FieldProps, UiSchema } from "@rjsf/utils";
import React, { useEffect, useRef, useState } from "react";

export const getAllowedZipCodes = (uiSchema: UiSchema): string[] => {
  const options = uiSchema["ui:options"];
  if (options && options.zipCodes && typeof options.zipCodes === "string") {
    const zipCodesComaSeparated = options.zipCodes;
    return zipCodesComaSeparated
      .split(",")
      .map((value) => value.trim())
      .filter((value) => value !== "");
  }
  return [];
};
export const ZipCodeField: Field = (props: FieldProps) => {
  const [fieldValue, setFieldValue] = useState<string | undefined>(props.formData as string | undefined);
  const ref = useRef<HTMLInputElement>(null);
  // Tracks whether fieldValue originates from user input. Emitting onChange for the prefilled
  // (edit) value on mount feeds it back into rjsf and re-renders the form in a loop; only real
  // edits should propagate.
  const userEdited = useRef(false);
  const allowedZipCodes = props.uiSchema ? getAllowedZipCodes(props.uiSchema) : [];
  const resetError = (): void => {
    ref.current?.setCustomValidity("");
  };

  useEffect(() => {
    // Only propagate user edits — never the initial/prefilled value synced from props.formData.
    if (!userEdited.current || fieldValue === undefined) return;
    const trimmedFieldValue = fieldValue.trim();
    if (allowedZipCodes.length === 0 || allowedZipCodes.includes(trimmedFieldValue)) {
      resetError();
      props.onChange(fieldValue, props.fieldPathId.path);
    } else {
      ref.current?.setCustomValidity("Eine Anmeldung von Ihrem Wohnort ist nicht erlaubt.");
      props.onChange(undefined, props.fieldPathId.path);
    }
  }, [fieldValue]);

  return (
    <div className={"d-flex flex-wrap mx-0 my-0"}>
      <div className={"w-100 mb-0"}>
        <label htmlFor={props.name} className="form-label">
          {props.name}
        </label>
        <input
          ref={ref}
          type={"text"}
          id={props.name}
          name={props.name}
          defaultValue={fieldValue}
          required={props.required}
          className={"form-control"}
          onChange={(e) => {
            userEdited.current = true;
            setFieldValue(e.target.value);
          }}
        />
      </div>
    </div>
  );
};
